(function () {
	const productSlider = () => {
		document.querySelectorAll(".js-get-section").forEach((parent) => {
			const carousel = parent.querySelector(".js-swiper-product-carousel");
			const scrollBar = parent.querySelector(".js-product-carousel-swiper-scrollbar");
			const prev = parent.querySelector(".js-product-carousel-arrow-prev");
			const next = parent.querySelector(".js-product-carousel-arrow-next");

			if (!carousel) return;

			new Swiper(carousel, {
				slidesPerView: 1.2,
				spaceBetween: 20,
				slidesOffsetAfter: 20,
				scrollbar: {
					el: scrollBar,
					draggable: true,
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				breakpoints: {
					750: {
						slidesPerView: 1.2,
						spaceBetween: 20,
						slidesOffsetAfter: 0,
					},
					990: {
						slidesPerView: 2,
						spaceBetween: 24,
						slidesOffsetAfter: 0,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 24,
						slidesOffsetAfter: 0,
					},
				},
			});

			const navTools = parent.querySelector(".product-carousel_nav-tools");

			if (
				navTools &&
				(prev?.classList.contains("swiper-button-lock") ||
					next?.classList.contains("swiper-button-lock"))
			) {
				navTools.style.display = "none";
			}
		});
	};

	document.addEventListener("DOMContentLoaded", () => {
		productSlider();

		document.addEventListener("shopify:section:load", () => {
			productSlider();
		});
	});
})();